import { signal } from '@preact/signals-react'

// Controls when the demo popover is visible during the tour (steps 7–10)
export const demoPopoverOpen = signal(false)
